import React from 'react';
import './Help.css';

const Help = (props) => {
  return (
    <div className="serviceInfo">
      <span className="serviceInfoContainer">
        <h3 className="serviceTitle">Sorry... Under Construction...</h3>
      </span>
    </div>
  );
};

export default Help;
